import { render, staticRenderFns } from "./HighlightedServices.vue?vue&type=template&id=84636daa&scoped=true&"
import script from "./HighlightedServices.vue?vue&type=script&lang=js&"
export * from "./HighlightedServices.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedServices.vue?vue&type=style&index=0&id=84636daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84636daa",
  null
  
)

export default component.exports